export default __webpack_public_path__ + "static/media/logo.eb61876e.svg";